const lithiumData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133794/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_86b5c406-e222-4b36-8973-097c3adaa718_jmp7ye.png',
  priceAssessmentsBrochureFile: {
    file_name: 'Benchmark-Anode-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'anodePriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureAnodeFilePdfId',
    file_name: 'Anode Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Our annual Anode Forecast service includes a comprehensive anode supply model updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Plant-by-plant:</strong> MWh and tpa production data for every global anode active material facility through to 2040',
          '<strong>Chemistry focus:</strong> Anode active material production data broken down by chemistry type',
          '<strong>Expansions:</strong> Track all anode facility developments',
          '<strong>Customisation:</strong> A highly customisable supply model, including switchable units and adjustable assumptions to implement your own ideas',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719442371/assets/market/anode/data-reports/benchmarkminerals_batteries_photo_photorealistic_Hyper-realism__a48990a8-df95-4a76-bf5d-8f81a0476848_slprwt.png',
        alt: 'Lithium Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719442370/assets/market/anode/data-reports/benchmarkminerals_A_high-tech_battery_storage_facility_with_row_6e6d7681-a1e2-4941-b20c-3580e9c304fe_vmdzvg.png',
        alt: 'Lithium Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719442371/assets/market/anode/data-reports/benchmarkminerals_battery_factory_batteriesphotorealistic_reali_99f5b491-7673-4c25-8886-e52c79a3b75e_yellvy.png',
        alt: 'Lithium Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1719442370/assets/market/anode/data-reports/benchmarkminerals_3D_rendering_of_a_group_of_large-scale_storag_921a15b3-5b81-483c-8f14-47f5a0c9f8b2_scfz2y.png',
      title:
        'Benchmark’s Anode Forecast features detailed data and analysis for anode active material:',
      descriptions: [
        {
          items: [
            '<p class="mb-4"><strong>Market balances:</strong> Compare anode market balances by chemistry, tier and geography for a thorough view of the market</p>',
            '<p class="mb-4"><strong>Demand drivers:</strong> Chemistry-specific demand breakdowns for the EV, Stationary and Portable lithium-ion battery sectors out to 2040</p>',
            '<p class="mb-4"><strong>Regional perspectives:</strong> Observe anode supply and demand by region for a geographical view of the market</p>',
            '<p class="mb-4"><strong>Developments:</strong> Track key investments, partnerships and announcements over each quarter</p>',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1719442371/assets/market/anode/data-reports/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_3fc329a4-f738-4b47-ae32-d252c3e69aef_om2jaf.png',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Anode Forecast:',
      descriptions: [
        {
          items: [
            '<p class="mb-4"><strong>Online:</strong> accessible downloads available each quarter</p>',
            '<p class="mb-4"><strong>Clear and Concise:</strong> Your data is presented in Excel and pdf format</p>',
            '<p class="mb-4"><strong>Implement Your Ideas:</strong> Each file is fully customisable so you can input your own assumptions</p>',
          ],
        },
      ],
    },
  },
}
export default lithiumData
